import React from 'react';

import axios from 'axios';

import Divider from '@material-ui/core/Divider';

import Shared from '../Shared/Shared';
import FooterComponent from '../Shared/Component/FooterComponent';
import BroadcastMapComponent from './Component/BroadcastMapComponent';
import CarouselComponent from './Component/CarouselComponent';
import RainInfoTableComponent from './Component/RainInfoTableComponent';
import RainAlarmTableComponent from './Component/RainAlarmTableComponent';
import RainMapComponent from './Component/RainMapComponent';

import { Config } from '../../Config';
import '../../index.css';

import Image1 from '../../Resources/Image1.JPG';
import Image2 from '../../Resources/Image2.JPG';
import Image3 from '../../Resources/Image3.JPG';
import Image4 from '../../Resources/Image4.JPG';

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [
                {
                    'name': 'Random Name #1',
                    'url': Image1
                },
                {
                    'name': 'Random Name #2',
                    'url': Image2
                },
                {
                    'name': 'Random Name #3',
                    'url': Image3
                },
                {
                    'name': 'Random Name #4',
                    'url': Image4
                },
            ],
            rain_info_data: [],
            alarm_data: [],

            open: false,

            dialog: false,
        }
    }

    componentDidMount() {
        this.fetchData()
        this.fetchDataInterval = setInterval(() => this.fetchData(), 300000)
    }

    componentWillUnmount() {
        clearInterval(this.fetchDataInterval)
    }

    fetchData = () => {
        axios.get(Config() + '/home/get')
        .then(response => {
            if (response.data[0] === "OK") {
                this.setState({ 
                    rain_info_data: response.data[1],
                    alarm_data: response.data[2]
                })
            }
        })
        .catch(error => {
            console.log(error)
        })
    }

    expandTable = () => {
        this.setState({ open: !this.state.open })
    }

    goLogin = () => {
        this.props.history.push({ pathname: '/Login' })
    }

    closeLogin = () => {
        this.setState({ dialog: false })
    }

    render() {
        return (
            <div className="background">
                <Shared />
                
                <RainAlarmTableComponent data={this.state.alarm_data} />

                <br />
                <Divider />

                <RainInfoTableComponent data={this.state.rain_info_data} />

                <br />
                <Divider />

                <BroadcastMapComponent />

                <br />
                <Divider />

                <RainMapComponent />

                <br />
                <Divider />

                <CarouselComponent items={this.state.items} />

                <br />

                <FooterComponent />
            </div>
        )
    }
}

export default Home;